import styled from 'styled-components'

import { BREAKPOINTS } from 'Global/constants'
import { spacing, colors } from 'Global/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: ${({ device }) => device === BREAKPOINTS.DESKTOP ? '60%' : '100%'};

  margin-top: ${spacing.seven};
  margin-bottom: ${spacing.seven};
  padding: ${spacing.two} ${spacing.four};

  border-radius: 8px;
  border-style: solid;
  border-color: ${colors.primary.regular};
  border-width: 2px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

`

export const Section = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;

  margin-bottom: ${spacing.four};


  &.info {
    justify-content: flex-start;
    align-items: flex-start;

    > :not(:first-child) {
      margin-top: ${spacing.three};
    }
  }

  &.status {
    justify-content: center;
    align-items: center;

    > .successImg{
      max-width: 200px;
    }
  }
  
`

export const Block = styled.div`
  display: flex;
  flex-direction: ${({ device }) => device !== BREAKPOINTS.MOBILE ? 'row' : 'column'};
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  &.certs {
    align-items: flex-start;
    flex-direction: column;
    > svg {
      width: fit-content;
    }
  }

  p {
    margin: 0;
    font-size: 16pt;
  }

  > :first-child {
    font-size: 16pt;
    margin-right: ${spacing.half};
    font-weight: 600;
    flex: 1 1 100%;
  }
  > :last-child {
    left: ${spacing.three};
    flex: 1 1 100%;
  }

  .loading {
    height: 20px;
    display: flex;
    align-items: center;
    margin: ${spacing.two};
    > img {
      position: absolute !important;
    }
  }

  .download {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-top: ${spacing.one};

    > p {
      &:not(:first-child) {
        margin: ${spacing.two} 0 0 0;
      }

      width: max-content;
    }

    .certificate-container{
      display: flex;
      flex-direction: ${({ device }) => device === BREAKPOINTS.DESKTOP ? 'row' : 'column'};
      justify-content: space-between;
      margin: ${spacing.one} 0;
    }

    .certificate-description{
      padding-right: ${spacing.one};
    }

    .certificate{
      width: fit-content;
      height: fit-content;
      padding: ${spacing.one} ${spacing.two};
      border: 1px solid ${colors.primary.dark};
      border-radius: 8px;
      cursor: pointer;

      &:hover {
        color: ${colors.primary.regular};
        border: 1px solid ${colors.primary.regular};
      }
    }
  }
`
